import type { FreelancerWelcomePageLocales } from '../types';

const freelancerWelcomePageLocales: FreelancerWelcomePageLocales = {
  instructions1: `Leuk dat je via ons platform Tadaah aan de slag wilt gaan als freelancer in de kinderopvang. In deze aanmeldprocedure leer je alles over het werken via Tadaah. Vul je persoonlijke gegevens in en upload stapsgewijs alle benodigde documenten om te kunnen werken als freelancer in de kinderopvang.\n\n Bij elke stap wordt er met behulp van video’s en instructies uitgelegd wat er van je verwacht wordt. \n\n We starten met een introductievideo over Tadaah`,
  instructions2: `De volgende video vertelt je meer over de stappen die je moet doorlopen voordat je kunt starten met freelancen via Tadaah.`,
  nextVideo: 'Volgend filmpje',
  preferToReadInstructions: 'Liever de instructies lezen? ',
  start: 'Start aanmeldprocedure',
  title: 'Welkom',
  welcomeDialogInstructions: `
Om te kunnen werken als freelancer in de kinderopvang moet je aan verschillende eisen voldoen. 
In deze aanmeldprocedure nemen we je stapsgewijs mee; welke eisen er zijn en welke documenten je daarvoor moet uploaden.
Aan bod komen:
  \t•  Je persoonlijke - en bedrijfsgegevens.
  \t•  Je inschrijving bij de KVK.
  \t•  Inschrijving in het Personenregister Kinderopvang (PRK).
  \t•  Bedrijfsaansprakelijkheidsverzekering.
  \t•  Je behaalde diploma’s en certificaten.

Daarnaast beantwoord je enkele vragen over Tadaah.

Je wordt zo door ons aanmeldprocedure geleid. Regelmatig krijg je een overzicht van je voortgang in de aanmeldingsprocedure te zien.
  `,
};

export default freelancerWelcomePageLocales;
